import { Component, Input } from '@angular/core';

@Component({
  selector: 'header-form-cadastro-paciente',
  templateUrl: './header-form-cadastro-paciente.component.html',
  styleUrls: ['./header-form-cadastro-paciente.component.scss']
})
export class HeaderFormCadastroPacienteComponent {

  @Input() porcentagem: number = 0;
  @Input() existeCadastro: boolean = false;
}
